import { EVENT_PROPERTY_TYPES } from "@redotech/redo-model/external-apis/custom-events/create-custom-event";
import * as z from "zod/v4";

export const eventPropertyTypeSchema = z.enum(EVENT_PROPERTY_TYPES);

export const getCustomEventPropertyKeys = {
  name: "getCustomEventPropertyKeys" as const,
  input: z.object({ eventName: z.string() }),
  output: z.object({
    properties: z.array(
      z.object({ key: z.string(), type: eventPropertyTypeSchema }),
    ),
  }),
};
